// CSS
import "./TanStackTablePagination.css";

// MUI IMPORTS
import { Box, IconButton, MenuItem, Select, Typography } from "@mui/material";

// MUI ICONS
import {
	ArrowBack,
	ArrowForward,
	FirstPage,
	LastPage,
} from "@mui/icons-material";

const TanStackTablePagination = (props) => {
	// RENDER
	return (
		<>
			<div id="tanStackTablePaginationContainer">
				<Box
					display="flex"
					alignItems="center"
					justifyContent="center"
					gap={2}
					mt={1}
				>
					{/* First Page */}
					<IconButton
						onClick={() => props.table.setPageIndex(0)}
						disabled={!props.table.getCanPreviousPage() || props.disabled}
					>
						<FirstPage />
					</IconButton>

					{/* Previous Page */}
					<IconButton
						onClick={() => props.table.previousPage()}
						disabled={!props.table.getCanPreviousPage() || props.disabled}
					>
						<ArrowBack />
					</IconButton>

					{/* Page Info */}
					<Typography>
						{props.table.getPageCount() === 0
							? "0 out of 0"
							: `Page ${
									props.table.getState().pagination
										.pageIndex + 1
							  } of ${props.table.getPageCount()}`}
					</Typography>

					{/* Records Per Page Dropdown */}
					<Select
						value={props.pagination.pageSize}
						onChange={(e) => {
							props.table.setPageSize(Number(e.target.value));
						}}
						disabled={props.disabled}
						size="small"
					>
						<MenuItem value={5}>5</MenuItem>
						<MenuItem value={10}>10</MenuItem>
						<MenuItem value={25}>25</MenuItem>
						<MenuItem value={50}>50</MenuItem>
						<MenuItem value={100}>100</MenuItem>
					</Select>

					{/* Next Page */}
					<IconButton
						onClick={() => props.table.nextPage()}
						disabled={!props.table.getCanNextPage() || props.disabled}
					>
						<ArrowForward />
					</IconButton>

					{/* Last Page */}
					<IconButton
						onClick={() =>
							props.table.setPageIndex(
								props.table.getPageCount() - 1
							)
						}
						disabled={!props.table.getCanNextPage() || props.disabled}
					>
						<LastPage />
					</IconButton>
				</Box>
			</div>
		</>
	);
};

export default TanStackTablePagination;
